import styled from 'styled-components';

export const Conteiner = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  width: 100%;
`;

export const Texto = styled.span``;

export const Borda = styled.span`
  position: absolute;
  left: 0;

  width: ${(props) => (props.error ? '100%' : 0)};
  height: 2px;

  background-color: ${(props) => (props.error ? props.theme.DANGER : props.theme.PRIMARY)};
  bottom: 0;

  transition: 0.4s;
`;

export const InputField = styled.textarea`
  width: 100%;
  min-width: 500px;
  min-height: 200px;

  color: ${(props) => props.theme.DARK};
  background-color: ${(props) => props.theme.MEDIUM};
  border: 0;
  border-bottom: 1px solid #ccc;
  box-sizing: border-box;

  font:
    15px/24px 'Lato',
    arial,
    sans-serif;
  letter-spacing: 1px;

  &:focus {
    outline: none;
    outline-offset: 0;
  }

  &:focus ~ ${Borda} {
    width: 100%;
  }

  &:disabled {
    opacity: 0.7;
  }
`;

export const TextoDeErro = styled.span`
  color: ${(props) => props.theme.DANGER};
`;

export const ConteinerInput = styled.div`
  display: flex;

  width: 100%;
`;

export const ConteinerIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  padding: 0 10px;
`;
